var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('FlatCard',{attrs:{"refresh":_vm.onRefresh}},[_c('v-card-text',[_c('FlatTable',{ref:"table",attrs:{"itemsPerPage":50,"getter":_vm.getter,"headers":_vm.headers},scopedSlots:_vm._u([{key:"item.balance",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("currency")(item.balance))+" ")]}},{key:"item.created_at",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.$format.asDateTime(item.created_at))+" ")]}}])})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }